<template lang="pug">
  b-modal#editBankGroup(
  ref="editBankGroup"
  :title="$t('ui.combine.edit_bank_group')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.group_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="group_id"
          required
          type="text"
          :dirty="$v.group_id.$dirty"
          :error="$v.group_id.$error"
          v-model.trim.lazy="$v.group_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.group_id" :name="$t('ui.group_id')")
      b-form-group(:label="$t('ui.group_name')").mb-0
        DebounceInput(
          size="sm"
          ref="group_name"
          required
          type="text"
          :dirty="$v.group_name.$dirty"
          :error="$v.group_name.$error"
          v-model.trim.lazy="$v.group_name.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.group_name" :name="$t('ui.group_name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      group_id: "",
      group_name: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    group_id: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(20)
    },
    group_name: {
      required,
      alphaNumWithSpace,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.bankGroupEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          group_id: this.group_id.trim(),
          group_name: this.group_name.trim(),
          audit_by: this.$store.getters.loginId
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editBankGroup.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_bank_group", this.feedback.status);
                  this.$refs.editBankGroup.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.group_id = this.item.group_id;
      this.group_name = this.item.group_name;
      this.$refs.group_name.$el.focus();
    }
  }
};
</script>
